export const ROARING = 'roaring'
export const ACCUSATORY = 'accusatory'
export const REELING = 'reeling'
